export const primaryColor = 'rgb(0, 0, 155)';
export const secondaryColor = 'rgb(253, 98, 46)';
export const thirdColor = 'rgb(74, 140, 246)';
export const fourthColor = 'rgb(255, 64, 129)';
export const disabledColor = 'rgb(154, 154, 154)';
export const highlightColor = 'rgb(202, 202, 202)';
export const selectedColor = 'rgb(164, 198, 57)';

export const successColor = 'rgb(60, 118, 61)';
export const successBackColor = 'rgb(223, 240, 216)';
export const successBorderColor = 'rgb(214, 233, 198)';
export const infoColor = 'rgb(49, 112, 143)';
export const infoBackColor = 'rgb(217, 237, 247)';
export const infoBorderColor = 'rgb(188, 232, 241)';
export const warningColor = 'rgb(138, 109, 59)';
export const warningBackColor = 'rgb(252, 248, 227)';
export const warningBorderColor = 'rgb(250, 235, 204)';
export const alertColor = 'rgb(169, 68, 66)';
export const alertBackColor = 'rgb(242, 222, 222)';
export const alertBorderColor = 'rgb(235, 204, 209)';
export const rateColor = 'rgb(243, 156, 18)';

export const row = {
    maxWidth: '79rem',
    marginLeft: 'auto',
    marginRight: 'auto',
};

export const rowMenu = {
    maxWidth: '79rem',
    width: 'calc(100% - 92px)',
    marginLeft: 'auto',
    marginRight: '0',
};

export const rowLogo = {
    maxWidth: '79rem',
    marginLeft: 'auto',
    marginRight: 'auto',
};

export const page = {
    display: 'flow-root',
    boxSizing: 'border-box',
    height: 'calc(100% - 86px)',
    paddingTop: '.5em',
};

export const baseButton = {
    padding: '.5em',
    fontFamily: 'IRANSans, Arial, sans-serif',
    fontSize: '0.9em',
    borderTop: 'none',
    borderBottom: 'none',
    borderLeft: 'none',
    borderRight: 'none',
    cursor: 'pointer',
    outline: 'none',
    minWidth: '6em',
    marginTop: '0',
    marginBottom: '0',
    marginLeft: '0',
    marginRight: '0',
};

export const mark_baseButton = {
    padding: '.5em',
    fontFamily: 'IRANSans, Arial, sans-serif',
    fontSize: '0.9em',
    borderTop: 'none',
    borderBottom: 'none',
    borderLeft: 'none',
    borderRight: 'none',
    cursor: 'pointer',
    outline: 'none',
    minWidth: '6em',
    marginTop: '10px',
    marginBottom: '0',
    marginLeft: '0',
    marginRight: '0',
    display: 'block'
};

export const mark_button = {
    ...mark_baseButton,
    backgroundColor: 'white',
    color: 'black',
    borderRadius: '.15em',
    boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px',
};

export const button = {
    ...baseButton,
    backgroundColor: 'white',
    color: 'black',
    borderRadius: '.15em',
    boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px',
};

export const defaultButton = {
    ...button,
    color: 'white',
    backgroundColor: thirdColor,
};

export const mark_orange_button = {
    ...mark_button,
    color: 'white',
    backgroundColor: secondaryColor,
};

export const mark_errorButton = {
    ...mark_button,
    color: 'white',
    backgroundColor: fourthColor,
};

export const mark_defaultButton = {
    ...mark_button,
    color: 'white',
    backgroundColor: thirdColor,
};
export const lastmark_defaultButton = {
    ...mark_button,
    color: thirdColor,
    borderColor: thirdColor,
    border: "2px solid",
    borderRadius: "1em",
    backgroundColor: 'white',
    minWidth: "255px",
    overflow: "hidden"
};
export const highButton = {
    ...button,
    color: 'black',
    backgroundColor: highlightColor,
};

export const mark_highButton = {
    ...mark_button,
    color: 'black',
    backgroundColor: highlightColor,
};

export const activeButton = {
    ...button,
    color: 'white',
    backgroundColor: thirdColor,
};

export const tabButton = {
    ...baseButton,
    backgroundColor: 'white',
    borderBottom: '.25em solid #cacaca',
    color: 'black',
};

export const activeTabButton = {
    ...tabButton,
    backgroundColor: 'white',
    color: thirdColor,
    borderBottom: `.25em solid ${thirdColor}`,
};

export const rightTabButton = {
    ...baseButton,
    backgroundColor: 'white',
    borderLeft: '.25em solid #cacaca',
    color: 'black',
};

export const activeRightTabButton = {
    ...rightTabButton,
    backgroundColor: 'white',
    color: thirdColor,
    borderLeft: `.25em solid ${thirdColor}`,
};

export const shadowBox = {
    padding: '.5em',
    border: 'none',
    boxSizing: 'border-box',
    outline: 'none',
    borderRadius: '.15em',
    boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px',
};

export const input = {
    ...shadowBox,
    lineHeight: '1.7em',
    height: '2.7em',
    fontFamily: 'IRANSans, Arial, sans-serif',
    fontSize: '0.9em',
    ':focus': {
        backgroundColor: '#fafafa',
        border: `.0625em solid ${thirdColor}`,
    },
};

export const numberInput = {
    ...input,
    direction: 'ltr',
    textAlign: 'right',
};

export const tag = {
    margin: '.2em',
    paddingTop: '.2em',
    paddingBottom: '.2em',
    paddingLeft: '.5em',
    paddingRight: '.5em',
    fontSize: '.6em',
    display: 'inline-block',
    backgroundColor: '#a9b9e0',
    borderRadius: '.8em',
};

export const error = {
    color: fourthColor,
    fontSize: '.8em',
    marginTop: '-.9em',
    marginBottom: '.9em',
};

export const overlay = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    height: '100%',
    backgroundColor: 'rgba(60, 60, 60, .93)',
    zIndex: 1000,
    overflow: 'hidden',
    transition: 'background-color 1.2s linear',
};

export const container = {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    overflowY: 'auto',
};

export const dialog = {
    transition: 'max-height 1.2s, padding 1.2s, margin-top 1.2s, border-width 1.2s',
    backgroundColor: 'white',
    paddingTop: '1em',
    paddingBottom: '1em',
    paddingLeft: '2em',
    paddingRight: '2em',
    borderWidth: '.0625em',
    borderStyle: 'solid',
    borderColor: 'black',
    borderRadius: '3px',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.4)',
    marginTop: '4em',
    marginBottom: 'auto',
    maxWidth: '90%'
};

export const header = {
    textAlign: 'center',
    width: '100%',
    fontSize: '1.3em',
    marginBottom: '1.5em',
};

export const field = {
    ...input,
    width: '100%',
    marginBottom: '1em',
};

export const numberField = {
    ...numberInput,
    width: '100%',
    marginBottom: '1em',
};

export const checkboxField = {
    display: 'inline-block',
    borderWidth: undefined,
    borderStyle: undefined,
    borderColor: undefined,
};

export const dialogButtonContainer = {
    width: '100%',
    float: 'right',
    textAlign: 'center',
    marginBottom: '1em',
};

export const dialogButton = {
    ...button,
    width: '33%',
    fontSize: '1em',
};
export const dialogButton_large = {
    ...button,
    width: '50%',
    fontSize: '1em',
};

export const defaultDialogButton = {
    ...defaultButton,
    width: '33%',
    fontSize: '1em',
};
export const reset_pass_btn = {
    color: thirdColor,
    cursor: 'pointer'

};


export const loginDialog = {
    width: '20em',
    maxWidth: '100%',
};

export const registerDialog = {
    width: '34em',
    maxWidth: '100%',
};

export const welcomeDialog = {
    width: '34em',
    maxWidth: '100%',
};

export const registerDialogField = {
    '@media (min-width: 38em)': {
        width: 'calc(50% - .3em)',
        float: 'right',
        boxSizing: 'border-box',
    },
};

export const registerRightDialogField = {
    ...registerDialogField,
    clear: 'right',
    '@media (min-width: 38em)': {
        ...registerDialogField['@media (min-width: 38em)'],
        marginLeft: '.3em',
    },
};

export const registerLeftDialogField = {
    ...registerDialogField,
    clear: 'left',
    '@media (min-width: 38em)': {
        ...registerDialogField['@media (min-width: 38em)'],
        marginRight: '.3em',
    },
};

export const table = {
    borderCollapse: 'collapse',
    border: '.0625em solid #888888',
    padding: '.3em',
    fontSize: 'inherit',
};

export const tr = {
    border: '.0625em solid #888888',
    padding: '.3em',
};

export const th = {
    border: '.0625em solid #888888',
    padding: '.3em',
    direction: 'ltr',
    textAlign: 'center',
};

export const td = {
    border: '.0625em solid #888888',
    padding: '.3em',
    direction: 'ltr',
    textAlign: 'center',
};

export const softTd = {
    verticalAlign: 'middle',
    lineHeight: '2em',
    borderTop: '.0625em solid #eaeaea',
    borderBottom: '.0625em solid #eaeaea',
    whiteSpace: 'nowrap',
    textAlign: 'right',
    paddingLeft: '.5em',
    paddingRight: '.5em',
    fontSize: '.85em',
};

export const softTh = {
    verticalAlign: 'middle',
    lineHeight: '2em',
    borderTop: '.0625em solid #eaeaea',
    borderBottom: '.0625em solid #eaeaea',
    whiteSpace: 'nowrap',
    textAlign: 'right',
    paddingLeft: '.5em',
    paddingRight: '.5em',
    backgroundColor: '#eaeaea',
    fontSize: '.9em',
};

export const centeredTd = {
    border: '.0625em solid #888888',
    padding: '.3em',
    direction: 'ltr',
    textAlign: 'center',
};

export const box = {
    border: '.25em solid #4070ff',
    borderRadius: '1em',
    padding: '1em',
    boxSizing: 'border-box',
};

export const content = {
    fontFamily: 'IRANSans',
    fontSize: '11pt',
};

export const tagArrow = (direction, color = 'black') => {
    const borderColor = new Array(4);
    borderColor.fill('transparent', 0, 4);
    if (typeof direction === 'string')
        direction = {
            top: 2,
            bottom: 0,
            left: 1,
            right: 3,
        }[direction];
    const offset = {
        0: 'top',
        1: 'left',
        2: 'bottom',
        3: 'right',
    }[direction];
    borderColor[direction] = color;
    return {
        position: 'absolute',
        [offset]: '100%',
        borderStyle: 'solid',
        borderWidth: '1em',
        borderColor: borderColor.join(' '),
    };
};

export const info = {
    position: 'absolute',
    top: '100%',
    right: '50%',
    transform: 'translateX(50%)',
    backgroundColor: '#cacaca',
    border: '.0625em solid black',
    padding: '.5em',
    fontSize: '.8em',
    width: '20em',
};

export const tooltip = active => ({
    position: 'absolute',
    top: active ? '100%' : 'calc(100% - .5em)',
    right: '50%',
    transform: 'translateX(50%)',
    backgroundColor: 'rgba(97, 97, 97, .97)',
    color: 'white',
    borderRadius: '2px',
    height: '2em',
    zIndex: '100',
    fontSize: '.8em',
    transition: 'all .3s cubic-bezier(.55,0,.55,.2)',
    opacity: active ? '1' : '0',
    padding: '.5em',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    whiteSpace: 'nowrap',
});

export const PDialogStyle = {
    width:"100%",
    overflowY: 'auto',
    overflowX: 'auto',
    height: 'calc(100% - 2.9em)',
    marginBottom: '.3em',
};